import React from "react";
import { MoreVerticalIcon } from "lucide-react";
import styles from "../../_css/ContenetManagement.module.css";

const FaqsCard = ({
    faq,
    index,
    actualIndex,
    openIndex,
    menuOpenIndex,
    menuOpenIndexSecond,
    isLeftColumn,
    toggleFAQ,
    toggleMenu,
    toggleMenuSecond,
    handleMenuAction,
    getMenuOptions,
}) => {

    const isOpen = openIndex === actualIndex;
    const menuIndex = isLeftColumn ? menuOpenIndex : menuOpenIndexSecond;
    const toggleMenuFn = isLeftColumn ? toggleMenu : toggleMenuSecond;

    return (
        <div className={`${styles.FaqsCard} ${isOpen ? styles.open : ""}`}>
            {/* Header */}
            <div className={styles.header} onClick={() => toggleFAQ(actualIndex)}>
                {/* Question + Status */}
                <div className={styles.headerLeft}>
                    <span className={styles.question}>{faq.question}</span>

                    <button
                        className={`${styles.statusButton} ${faq.status === "Publish" ? styles.published : styles.draft
                            }`}
                    >
                        {faq.status}
                    </button>
                </div>

                {/* Right Controls */}
                <div className={styles.headerRight}>
                    {/* Three dots menu */}
                    <div
                        className={styles.menuTrigger}
                        data-menu-trigger
                        onClick={(e) => {
                            // console.log("Clicked on div")
                            e.stopPropagation();
                            toggleMenuFn(index, e);
                        }}
                    >
                        <MoreVerticalIcon size={20} color="#1F2937" />
                    </div>

                    {menuIndex === index && (
                        <div
                            className={styles.dropdownMenu}
                            data-dropdown-menu
                            onMouseDown={(e) => e.stopPropagation()}
                        >
                            {getMenuOptions(faq.status).map((item, idx) => (
                                <div
                                    key={idx}
                                    className={styles.dropdownItem}
                                    onClick={(e) => {
                                        // console.log("clicked")
                                        e.stopPropagation();
                                        handleMenuAction(
                                            item,
                                            faq,
                                            isLeftColumn ? "left" : "right",
                                            index,
                                            e
                                        );
                                    }}
                                >
                                    {item}
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Expand Button */}
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            toggleFAQ(actualIndex);
                        }}
                        className={styles.toggleBtn}
                    >
                        {isOpen ? "×" : "+"}
                    </button>
                </div>
            </div>

            {/* Answer */}
            <div
                className={`${styles.answerWrapper} ${isOpen ? styles.answerOpen : ""
                    }`}
            >
                <p className={styles.answer}>{faq.answer}</p>
            </div>
        </div>
    );
};

export default FaqsCard;